// deactivate extras
// transfer | hotel code empty

import _ from 'lodash';
import * as storage from './storage';
import { checkCurrentDateIsBefore, checkTripStarts } from './checkTripStarts';
import { resolveTravelType } from './bookingHelper';

export function deactivateExtras() {
    if (storage.get('bookingData') !== null) {
        let getBookingData = storage.get('bookingData').data;
        const travelType = resolveTravelType(getBookingData);
        const { extras } = window.$content;
        if (!extras) {
            return;
        }

        // if transfer not already booked
        if (getBookingData.serviceInformation && getBookingData.serviceInformation.transfer === undefined) {
            if (getBookingData.searchParams.hotelCode?.length === 0 && extras.transfer) {
                extras.transfer.active = false;
            }
        }

        // deactivate railAndFly & transfer in hotel only case
        if (travelType === 'hotel') {
            if (extras['railAndFly'] !== undefined) {
                extras['railAndFly'].active = false;
            }

            if (extras['transfer'] !== undefined) {
                extras['transfer'].active = false;
            }
        }

        // delete transfer service : hotel serviceInformation not defined
        if (getBookingData.serviceInformation !== undefined && getBookingData.serviceInformation.hotel === undefined) {
            delete extras['transfer'];
        }

        // check if the return date is before today
        // isMediated → check if the booking is mediated
        if (getBookingData?.isMediated || checkCurrentDateIsBefore(getBookingData.searchParams.retDate)) {
            if (extras.excursion) {
                extras.excursion.active = false;
            }
        }

        // deactive seat reservation
        // isMediated → check if the booking is mediated
        if (
            getBookingData?.isMediated ||
            (getBookingData.serviceInformation !== undefined &&
                (getBookingData.serviceInformation.flight === undefined ||
                    getBookingData?.allowSeatReservations === false))
        ) {
            if (extras.seatReservation) {
                extras.seatReservation.active = false;
            }
        }

        // deactivate transfer based on travelType
        if (extras?.transferCruise && window.$content.extras['transferCruise'].active) {
            extras.transferCruise.active = travelType === 'cruise';
        }
        if (extras?.transfer && window.$content.extras['transfer'].active) {
            extras.transfer.active = travelType === 'package';
        }

        // Prüfung auf Anreisedatum, dass dieses nicht heute, morgen oder in der Vergangenheit ist. Ansonsten bitte "Transfer", "Versicherung", "Rail & Fly" ausblenden
        if (storage.get('bookingData') != null && storage.get('bookingData').data != null) {
            if (checkTripStarts()) {
                let s = ['transfer', 'insurance', 'railAndFly'];
                _.forEach(s, function (v) {
                    if (window.$content.extras[v]?.active !== undefined) {
                        window.$content.extras[v].active = false;
                    }
                });
            }
        }
    }
}
